import useGetSyncPromise from './useGetSyncPromise';
import {SyncPromise, GetSyncPromiseOptions} from '../abstractGetSyncPromise';

export default function useSyncPromise<T>(
    promise: Promise<T> | T,
    defaultValue?: T,
    options?: GetSyncPromiseOptions
): SyncPromise<T> {
    const getSyncPromise = useGetSyncPromise(options);
    return getSyncPromise(promise, defaultValue);
}
